<template>
	<div class="yiContainer">
		<div class="">
			<!-- 导航 -->
			<div class="navBar">
				<img class="navLogo" src="../assets/logo2.png" alt="" @click="enterHome()" />
				<ul class="navBarItem">
					<!-- <li class="busiz-active-sel">
						<router-link exact to="/" tag="a">首页</router-link>
					</li> -->
					<li>
						<router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link>
					</li>
					<el-dropdown>
						<li class="brandLi">
							<router-link exact to="/huaiBrand" style="font-size: 1em" tag="a">兰树品牌</router-link>
						</li>
						<el-dropdown-menu class="elDropdown" exact slot="dropdown"
							style="background: rgb(236, 245, 255) !important">
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '1' ? 'elDropdown_active' : ''"
										style="background: rgb(236, 245, 255) !important; color: #000 !important; "
										to="/huaiBrand" tag="a">
										淮树</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '2' ? 'elDropdown_active' : ''"
										style="background: rgb(236, 245, 255) !important; color: #000 !important; "
										to="/brand" tag="a">心清堂
									</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '3' ? 'elDropdown_active' : ''"
										style="background: rgb(236, 245, 255) !important; color: #000 !important; "
										to="/shuiBrand" tag="a">
										水姻缘</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '4' ? 'elDropdown_active' : ''"
										style=" background: rgb(236, 245, 255) !important; color: #000 !important;"
										to="/yiBrand" tag="a">
										一清堂</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '5' ? 'elDropdown_active' : ''"
										style=" background: rgb(236, 245, 255) !important; color: #000 !important;"
										to="/zhongBrand" tag="a">
										Dr.CHUNG<span style="vertical-align: super;">+</span></router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '6' ? 'elDropdown_active' : ''"
										style=" background: rgb(236, 245, 255) !important; color: #000 !important;"
										to="/lanshuBrand" tag="a">兰树</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '6' ? 'elDropdown_active' : ''"
										style=" background: rgb(236, 245, 255) !important; color: #000 !important;"
										to="/zbqfBrand" tag="a">植本清方</router-link>
								</li>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
					<li>
						<router-link to="/brandLanshu" exact tag="a">美业菩提</router-link>
					</li>
					<li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>

					<li>
						<router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link>
					</li>

					<li>
						<router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link>
					</li>
				</ul>
			</div>

			<!-- <div class="topImg">
		  <img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-16_16-11-01_92629.png" alt="">
		</div> -->
		</div>



		<!-- 创建外部展示容器 -->
		<div class="banner-container clearfix">
			<!-- 创建图片存储容器 -->
			<div style="width:100%;height:100%;">
				<!-- 引入轮播图图片 -->

				<swiper :options="topOption">
					<swiper-slide style="width:100%;height:100%;"><img style="width:100%;height:100%;"
							@click="enterProducts(2)"
							src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-06-20_16-26-38_48364.png"
							alt="" /></swiper-slide>
					<swiper-slide style="width:100%;height:100%;"><img style="width:100%;height:100%;"
							src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-06-20_16-27-16_92560.png"
							alt="" /></swiper-slide>
					<!-- <swiper-slide style="width:100%;height:100%;"><img style="width:100%;height:100%;" src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-06-20_16-27-39_80995.jpg" alt=""/></swiper-slide>
					<swiper-slide style="width:100%;height:100%;"><img style="width:100%;height:100%;" src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-06-20_16-28-04_74447.jpg" alt=""/></swiper-slide>
					<swiper-slide style="width:100%;height:100%;"><img style="width:100%;height:100%;" src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-06-20_16-28-21_35375.jpg" alt=""/></swiper-slide>
					<swiper-slide style="width:100%;height:100%;"><img style="width:100%;height:100%;" src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-06-20_16-28-40_46015.jpg" alt=""/></swiper-slide>
					<swiper-slide style="width:100%;height:100%;"><img style="width:100%;height:100%;" src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-07-07_15-04-33_3041.jpg" alt=""/></swiper-slide> -->
				</swiper>
			</div>
		</div>

		<div class="navigation" :class="{ fixed: isFixed }">
			<div class="nav_title" style="margin-right: 2.08vw;" @click="showHomePage">主页</div>
			<div class="nav_title" style="margin-right: 2.08vw;" @click="showProduct">单品系列</div>
			<div class="nav_title" @click="showSeries">套盒系列</div>
		</div>

		<div class="homepage" v-show="homepage">
			<!-- 品牌关键字 -->
			<div class="brandKeywords">
				<div class="keyLeft slide-left">
					<div class="left_bg">
						<img src="../assets/xinqingBrand/assets/left_bg.png" alt="">
					</div>
					<div class="core_value">
						<img src="../assets/xinqingBrand/assets/core_value.png" alt="">
					</div>
					<div class="idea">
						<img src="../assets/xinqingBrand/assets/idea.png" alt="">
					</div>
					<div class="mission">
						<img src="../assets/xinqingBrand/assets/mission.png" alt="">
					</div>
					<div class="location">
						<img src="../assets/xinqingBrand/assets/location.png" alt="">
					</div>
					<div class="slogan">
						<img src="../assets/xinqingBrand/assets/slogan.png" alt="">
					</div>
				</div>

				<div class="keyRight slide-right">
					<div class="right_bg">
						<img src="../assets/xinqingBrand/assets/right_bg.png" alt="">
					</div>
					<div class="feature">
						<img src="../assets/xinqingBrand/assets/feature.png" alt="">
					</div>
					<div class="vision">
						<img src="../assets/xinqingBrand/assets/vision.png" alt="">
					</div>
					<div class="key">
						<img src="../assets/xinqingBrand/assets/key.png" alt="">
					</div>
				</div>
			</div>

			<!-- 品牌介绍 -->
			<div class="brandIntroduce">
				<div class="orange"></div>
				<!-- 管家 -->
				<div class="butler">
					<div class="butler_en">YOUR EXCLUSIVE AI REPAIR BUTLER</div>
					<div class="butler_cn">你的专属AI修护管家</div>
					<div class="butler_img">
						<img src="../assets/xinqingBrand/assets/butler.png" alt="">
					</div>
					<div class="butler_detail slide-right">
						<div class="bd_cn">基于深厚的皮肤专业传承,将自然精萃与生物科技相融合，以“H+B+O”肌元三阶为配方原则,坚持“植本清方”、“理性护肤”打造对肌肤生态友好的养肤产品。
						</div>
						<div class="bd_en">Based on a deep skin expertise heritage,Combining natural essence with
							biotechnology,We take skin elements "H+B+O" three-stage as the formula principle.Therefore,
							adhere to "one skin and one recipe" and "rational skin care"that skin eco-friendly products
							are created.</div>
						<div class="bd_technology">TECHNOLOGY</div>
					</div>
				</div>

				<!-- 特色 -->
				<div class="characteristic">
					<div class="butler_en">YOUR EXCLUSIVE AI REPAIR BUTLER</div>
					<div class="butler_cn">心清堂品牌特色</div>
					<div class="tese_bg">
						<img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-09-19_66032.png"
							alt="">
					</div>
					<div class="characteristic_detail slide-right">
						<div class="tes_en">
							XINQINGTANG commits explore more scientific skin-care programs.AI skin detector can
							accurately analyze facial skin.Black tech blending & customized skin-care program
							to realize "one skin and one recipe".<br />
							<br />
							XINQINGTANG create original skin care formula H+B+O Which is High-tech biological skin-care
							technology compounded with plants essence.Construct a scientific skin care system with
							innovative formula that Every skin problem has its own intelligent solution.
						</div>
						<div class="tes_cn">
							心清堂致力于探索更为科学的护肤方案，AI智能测肤仪净精准解析面部肌肤，黑科技调配定制护肤方案，实现“植本清方”。<br />
							<br />
							独创护肤公式H+B+O，高科技生物护肤技术复配植物臻萃，以创新配方构建科学护肤体系，让每一种肌肤问题都有专属智御解法。
						</div>
						<div class="tes_technology">TECHNOLOGY</div>
					</div>
				</div>


				<!-- 理念 -->
				<div class="idealism">
					<div class="butler_en">YOUR EXCLUSIVE AI REPAIR BUTLER</div>
					<div class="butler_cn">心清堂品牌理念</div>
					<div class="idea_img">
						<img src="../assets/xinqingBrand/assets/idea_bg.png" alt="">
					</div>
					<div class="idea_detail slide-right">
						<div class="idea_cn">
							以“维护肌肤结构功能稳定”为第一原则，首要构建自在平衡的肌肤底气，逐级实现“维稳、莹靓、轻龄”的肌肤蜕变。<br />
							<br />
							我们坚持“植本清方”与“理性护肤”，提倡可持续的、长期主义的护肤方式，科学审视肌肤当下的需求。<br />
							<br />
							追求有效成分，合理分解各要素，夯实肌肤健康力、提升应变力、逆龄表现力，平衡微生态群，逐步渐进优化。<br />
							<br />
							给予肌肤向上生长的可持续能力，为消费者带来更健康的“自由肌”，我们始终坚信，肌肤值得被更科学地对待。
						</div>
						<div class="idea_en">
							principle to build a free and balanced skin foundation,realize the skin transformation of
							"stability, radiance and youthfulness" step by step.XISEIDO holds "one skin and one recipe"
							and "rational skin care" as brand concepts. <br />
							<br />
							We promote sustainable long-term skin-care mode,examine the current needs of the skin
							Scientifically.<br />
							<br />
							Pursue effective ingredients and decompose each element rationallyto Consolidate skin
							health, improve resilience, anti-aging performance.<br />
							<br />
							Balance micro-ecological group and optimize gradually to endow skin with sustainability for
							upward growth.—— "Healthier free skin for consumers."
							We always firmly believe that the skin deserves to be treated more scientifically.
						</div>
						<div class="idea_technology">TECHNOLOGY</div>
					</div>
				</div>

				<div class="orange_bottom">TECHNOLOGY MAKES BEAUTY REAL TECHNOLOGY MAKES BEAUTY REAL TECHNOLOGY MAKES
					BEAUTY REAL TECHNOLOGY MAKES BEAUTY REAL</div>


			</div>
		</div>

		<!-- 套盒系列 -->
		<div class="series" v-show="series">
			<div class="series_top">
				<div class="sstop_en slide-left">
					<img src="../assets/xinqingBrand/assets/sstop_en.png" alt="">
				</div>
				<div class="sstop_cn slide-left">
					<img src="../assets/xinqingBrand/assets/sstop_cn.png" alt="">
				</div>
				<div class="sstop_right slide-right">
					<div class="ssright_cn">
						套盒系列
					</div>
					<div class="ssright_en">
						SERIES
					</div>
				</div>
			</div>
			<!-- 源生赋新套 -->
			<div class="newSeries">
				<div class="orange"></div>

				<div class="ns_title">
					<div class="ns_cn">源生赋新套</div>
					<div class="ns_en">Technology empowerment<br />
						Rational skin care / Structural stability</div>
					<div class="bottom-title">
						<span class="yellow_left">适用肌肤：</span><span class="black_right">油性肌肤、中干性肌肤两款</span><br />
						<span class="yellow_left">适配人群：</span><span class="black_right">进阶护肤需求人群</span><br />
						<span class="yellow_left">套盒功效：</span><span
							class="black_right">充盈、修润、靓肤、轻龄，四重功效尊享SPA级奢宠护理，步步提升肌肤质感</span><br />
					</div>

					<span class="paragraph_24">SOURCE&nbsp;REGENERATING<br />SET</span>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/ysfx1.png" alt="" title="点击跳转商品详情">
					</div>
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/ysfx2.png" alt="" title="点击跳转商品详情">
					</div>
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/ysfx3.png" alt="" title="点击跳转商品详情">
					</div>

				</div>

			</div>


			<!-- 净澈盈彩眼部套 -->
			<div class="newSeries">
				<div class="orange"></div>

				<div class="ns_title">
					<div class="ns_cn">净澈盈彩眼部套</div>
					<div class="ns_en">Technology empowerment<br />
						Rational skin care / Structural stability
					</div>
					<div class="bottom-title">
						<span class="yellow_left">适用肌肤：</span><span class="black_right">适龄肌</span><br />
						<span class="yellow_left">适配人群：</span><span class="black_right">眼部护理需求人群</span><br />
						<span class="yellow_left">套盒功效：</span><span class="black_right">精细润护眼周，双眸精雕，绽放“睛”采</span><br />
					</div>

					<span
						class="paragraph_24">PURE&nbsp;LUSTER&nbsp;EYE&nbsp;CARE&nbsp;&nbsp;<br />SET&nbsp;&nbsp;</span>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper-slide">

					</div>
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/jcyc1.png" alt="" title="点击跳转商品详情">
					</div>
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/jcyc2.png" alt="" title="点击跳转商品详情">
					</div>

				</div>

			</div>

			<!-- 月光冰肌套 -->
			<div class="newSeries">
				<div class="orange"></div>

				<div class="ns_title">
					<div class="ns_cn">月光冰肌套</div>
					<div class="ns_en">Technology empowerment<br />
						Rational skin care / Structural stability
					</div>
					<div class="bottom-title">
						<span class="yellow_left">适用肌肤：</span><span class="black_right">适龄肌</span><br />
						<span class="yellow_left">适配人群：</span><span class="black_right">进阶护肤需求人群</span><br />
						<span class="yellow_left">套盒功效：</span><span
							class="black_right">平衡油脂，沁润靓泽，补充肌肤所需营养，悦享细腻靓颜</span><br />
					</div>

					<span class="paragraph_24"
						style="font-size: 1.98vw;">MOON&nbsp;REFRESHING&nbsp;SKINCARE&nbsp;<br />SET</span>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper-slide">

					</div>
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/ygbj1.png" alt="" title="点击跳转商品详情">
					</div>
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/ygbj2.png" alt="" title="点击跳转商品详情">
					</div>

				</div>

			</div>


			<!-- 蜜享绽妍套 -->
			<div class="newSeries">
				<div class="orange"></div>

				<div class="ns_title">
					<div class="ns_cn">蜜享绽妍套</div>
					<div class="ns_en">Technology empowerment<br />
						Rational skin care / Structural stability
					</div>
					<div class="bottom-title">
						<span class="yellow_left">适用肌肤：</span><span class="black_right">适龄肌</span><br />
						<span class="yellow_left">适配人群：</span><span class="black_right">高阶护肤需求人群</span><br />
						<span class="yellow_left">套盒功效：</span><span
							class="black_right">多重高科技活性护肤因子，释放元气肌能，定向修润，赋弹靓肤，蜜享年轻</span><br />
					</div>

					<span class="paragraph_24"
						style="font-size: 1.93vw;">DELUXE&nbsp;CHARMING&nbsp;SKINCARE&nbsp;&nbsp;<br />SET&nbsp;&nbsp;</span>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper-slide">

					</div>
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/mxzy1.png" alt="" title="点击跳转商品详情">
					</div>
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/mxzy2.png" alt="" title="点击跳转商品详情">
					</div>

				</div>

			</div>


			<!-- 百日面膜套 -->
			<div class="newSeries">
				<div class="orange"></div>

				<div class="ns_title">
					<div class="ns_cn">百日面膜套</div>
					<div class="ns_en">Technology empowerment<br />
						Rational skin care / Structural stability
					</div>
					<div class="bottom-title">
						<span class="yellow_left">适用肌肤：</span><span class="black_right">油性肌肤、中干性肌肤两款</span><br />
						<span class="yellow_left">适配人群：</span><span class="black_right">进阶护肤需求人群</span><br />
						<span class="yellow_left">套盒功效：</span><span
							class="black_right">黄金搭配经典面膜组合，多种臻萃精华协同赋能，修润维稳，密集守护晶透莹嫩肌</span><br />
					</div>

					<span class="paragraph_24"
						style="width: 30.05vw;text-align: left;">HUNDRED&nbsp;DAYS&nbsp;SET&nbsp;&nbsp;</span>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/brmm1.png" alt="" title="点击跳转商品详情">
					</div>
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/brmm2.png" alt="" title="点击跳转商品详情">
					</div>
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/brmm3.png" alt="" title="点击跳转商品详情">
					</div>

				</div>

			</div>

			<!-- 轻舒赋能套 -->
			<div class="newSeries">
				<div class="orange"></div>

				<div class="ns_title">
					<div class="ns_cn">轻舒赋能套 </div>
					<div class="ns_en">Technology empowerment<br />
						Rational skin care / Structural stability
					</div>
					<div class="bottom-title">
						<span class="yellow_left">适用肌肤：</span><span class="black_right">适龄肌</span><br />
						<span class="yellow_left">适配人群：</span><span class="black_right">有颈部放松、润靓需求的人群</span><br />
						<span class="yellow_left">套盒功效：</span><span
							class="black_right">润护颈部肌肤，平滑淡纹，使颈部嫩滑、靓莹</span><br />
					</div>

					<span class="paragraph_24"
						style="font-size: 2.14vw;">SOOTHING&nbsp;&&nbsp;RE-VITALIZING&nbsp;&nbsp;<br />SET</span>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper-slide"></div>
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/qsfn1.png" alt="" title="点击跳转商品详情">
					</div>
					<div class="swiper-slide">
						<img src="../assets/xinqingBrand/assets/qsfn2.png" alt="" title="点击跳转商品详情">
					</div>

				</div>

			</div>

		</div>



		<!-- 单品系列 -->
		<div class="product" v-show="product">
			<div class="series_top">
				<div class="sstop_en slide-left">
					<img src="../assets/xinqingBrand/assets/sstop_en.png" alt="">
				</div>
				<div class="sstop_cn slide-left">
					<img src="../assets/xinqingBrand/assets/sstop_cn.png" alt="">
				</div>
				<div class="sstop_right slide-right">
					<div class="ssright_cn">
						单品系列
					</div>
					<div class="ssright_en">
						SERIES
					</div>
				</div>
			</div>

      <!-- 多效修护系列 -->
			<div class="newSeries">
				<div class="orange"></div>

				<div class="ns_title">
					<div class="ns_cn">多效修护系列</div>
					<div class="pd_cn"  style="width: 30vw;">矩阵修护&nbsp;  一步到位</div>
					<!-- <div class="pd_en">TOUCHING<br />SKIN WITH<br />ELASTICITY</div> -->
					<div class="bottom-title" style="margin-top: 73px;">
						<span class="yellow_left">适用肌肤：</span><span class="black_right">敏感肌、屏障受损肌</span><br />
						<span class="yellow_left">适配人群：</span><span class="black_right">水油失衡、适龄人群</span><br />
						<span class="yellow_left">系列功效：</span><span
							class="black_right">抗皱紧致、舒缓修护、焕亮肌肤、稳固屏障</span><br />
					</div>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper">
						<swiper :options="swiperOption">
							<swiper-slide><img src="../assets/xinqingBrand/assets/xf1.png" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/xf2.png" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/xf3.png" alt=""
									title="点击跳转商品详情"></swiper-slide>
						</swiper>
					</div>

				</div>

			</div>


      <!-- 特品系列 -->
			<div class="newSeries">
				<div class="orange"></div>

				<div class="ns_title">
					<div class="ns_cn">特品系列</div>
					<div class="pd_cn"  style="width: 30vw;">矩阵修护&nbsp;  一步到位</div>
					<!-- <div class="pd_en">TOUCHING<br />SKIN WITH<br />ELASTICITY</div> -->
					<div class="bottom-title" style="margin-top: 73px;">
						<span class="yellow_left">适用肌肤：</span><span class="black_right">敏感肌肤、油痘肌肤</span><br />
						<span class="yellow_left">适配人群：</span><span class="black_right">肌肤粗糙不适、皮肤敏感泛红、油痘反复的人群</span><br />
						<span class="yellow_left">系列功效：</span><span
							class="black_right">抗皱紧致、舒缓修护、控油祛痘、稳固屏障</span><br />
					</div>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper">
						<swiper :options="swiperOption">
							<swiper-slide><img src="../assets/xinqingBrand/assets/fg1.png" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/fg2.png" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/fg3.png" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/fg4.png" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/fg5.png" alt=""
									title="点击跳转商品详情"></swiper-slide>

						</swiper>
					</div>

				</div>

			</div>


			<!-- 倾橙润舒臻颜系列 -->
			<div class="newSeries">
				<div class="orange"></div>

				<div class="ns_title">
					<div class="ns_cn">倾橙润舒臻颜系列</div>
					<div class="pd_cn">触见&nbsp; 肌肤嘭弹</div>
					<div class="pd_en">TOUCHING<br />SKIN WITH<br />ELASTICITY</div>
					<div class="bottom-title" style="margin-top: 73px;">
						<span class="yellow_left">适用肌肤：</span><span class="black_right">中干性肌肤</span><br />
						<span class="yellow_left">适配人群：</span><span class="black_right">皮肤干燥粗糙，缺乏弹性人群</span><br />
						<span class="yellow_left">系列功效：</span><span
							class="black_right">直击干燥，实力润舒，补充肌肤所需营养，锁住鲜嫩肌</span><br />
					</div>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper">
						<swiper :options="swiperOption">
							<swiper-slide><img src="../assets/xinqingBrand/assets/qcsh1.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/qcsh2.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/qcsh3.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/qcsh4.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/qcsh5.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>

						</swiper>
					</div>

				</div>

			</div>


			<!-- 青靛衡肤净颜系列 -->
			<div class="newSeries">
				<div class="orange" style="background-color: #17AE9E;"></div>

				<div class="ns_title">
					<div class="ns_cn">青靛衡肤净颜系列</div>
					<div class="pd_cn">回归&nbsp; 肌肤本真</div>
					<div class="pd_en">RECOVERIMG<br />SKIN TO<br />NATURALNESS</div>
					<div class="bottom-title" style="margin-top: 73px;">
						<span class="yellow_left" style="color: #17AE9E;">适用肌肤：</span><span
							class="black_right">油性肌肤</span><br />
						<span class="yellow_left" style="color: #17AE9E;">适配人群：</span><span
							class="black_right">水油失衡，毛孔粗大人群</span><br />
						<span class="yellow_left" style="color: #17AE9E;">系列功效：</span><span
							class="black_right">内源深入，调衡水油，清漾净颜，归正肌肤结构功能稳定</span><br />
					</div>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper">
						<swiper :options="swiperOption">
							<swiper-slide><img src="../assets/xinqingBrand/assets/qdhf1.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/qdhf2.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/qdhf3.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/qdhf4.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/qdhf5.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>

						</swiper>
					</div>

				</div>

			</div>


			<!-- 玉黛莹靓玉颜系列 -->
			<div class="newSeries">
				<div class="orange" style="background-color: #DBDCDC;"></div>

				<div class="ns_title">
					<div class="ns_cn">玉黛莹靓玉颜系列</div>
					<div class="pd_cn">焕彩&nbsp; 肌肤光蕴</div>
					<div class="pd_en">RADIANT<br />SKIN BRILIANT<br />SPIRIT</div>
					<div class="bottom-title" style="margin-top: 73px;">
						<span class="yellow_left" style="color: #231815;">适用肌肤：</span><span class="black_right"
							style="color: #717071;">适龄肌</span><br />
						<span class="yellow_left" style="color: #231815;">适配人群：</span><span class="black_right"
							style="color: #717071;">皮肤粗糙，有莹靓需求人群</span><br />
						<span class="yellow_left" style="color: #231815;">系列功效：</span><span class="black_right"
							style="color: #717071;">深润锁水，细腻莹肤，多维晶透，点靓肌肤光蕴 </span><br />
					</div>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper">
						<swiper :options="swiperOption">
							<swiper-slide><img src="../assets/xinqingBrand/assets/ydyl1.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/ydyl2.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/ydyl3.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/ydyl4.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/ydyl5.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/ydyl6.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
						</swiper>
					</div>

				</div>

			</div>


			<!-- 「 聚能黑科技 」 系列 -->
			<div class="newSeries">
				<div class="orange" style="background-color: #000000;"></div>

				<div class="ns_title">
					<div class="ns_cn"
						style="font-size: 66px;font-weight: 800;margin-left: -40px;font-family: SourceHanSansCN-Heavy;width: 640px;">
						「 聚能黑科技 」系列</div>
					<div class="pd_cn">瞬息&nbsp; 定格时光</div>
					<div class="pd_en" style="width: 590px;">INSTANTANEOUS<br />FIGHTING<br />AGEING</div>
					<div class="bottom-title" style="margin-top: 73px;">
						<span class="yellow_left" style="color: #231815;">适用肌肤：</span><span class="black_right"
							style="color: #717071;">适龄肌</span><br />
						<span class="yellow_left" style="color: #231815;">适配人群：</span><span class="black_right"
							style="color: #717071;">进阶护肤需求人群</span><br />
						<span class="yellow_left" style="color: #231815;">系列特点：</span><span class="black_right"
							style="color: #717071;">集眼部、面部、颈部多方位护理</span><br />
						<span class="yellow_left" style="color: #231815;">系列功效：</span><span class="black_right"
							style="color: #717071;">聚能黑科技，集多重高科技活性护肤因子，青春蕴能，无惧时光</span><br />
					</div>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper">
						<swiper :options="swiperOption">
							<swiper-slide><img src="../assets/xinqingBrand/assets/hkj1.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/hkj2.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/hkj3.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/hkj4.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/hkj5.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/hkj6.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/hkj7.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
						</swiper>
					</div>

				</div>

			</div>

			<!-- 「 聚能黑科技 」 冻干粉 -->
			<div class="newSeries">
				<div class="orange" style="background-color: #000000;"></div>

				<div class="ns_title">
					<div class="ns_cn"
						style="font-size: 66px;font-weight: 800;margin-left: -40px;font-family: SourceHanSansCN-Heavy;width: 700px;">
						「 聚能黑科技 」冻干粉</div>
					<div class="pd_cn">瞬息&nbsp; 定格时光</div>
					<div class="pd_en" style="width: 650px;">INSTANTANEOUS<br />FIGHTING<br />AGEING</div>
					<div class="bottom-title" style="margin-top: 73px;">
						<span class="yellow_left" style="color: #231815;">适用肌肤：</span><span class="black_right"
							style="color: #717071;">适龄肌</span><br />
						<span class="yellow_left" style="color: #231815;">适配人群：</span><span class="black_right"
							style="color: #717071;">进阶护肤需求人群</span><br />
						<span class="yellow_left" style="color: #231815;">系列特点：</span><span class="black_right"
							style="color: #717071;">以个性化调配，分肤分效，定制精准护肤方案</span><br />
						<span class="yellow_left" style="color: #231815;">系列功效：</span><span class="black_right"
							style="color: #717071;">将满满黑科技能量植入肌底，赋活肌能，释放肌源活力</span><br />
						<span class="yellow_left" style="color: #fff;">系列功效：</span><span class="black_right"
							style="color: #717071;">强健肌肤结构，蕴能焕彩，焕启本真年轻力</span><br />
					</div>
				</div>

				<!-- 轮播图 -->
				<div class="content" @click="enterProducts(2)">
					<div class="swiper">
						<swiper :options="swiperOption">
							<swiper-slide><img src="../assets/xinqingBrand/assets/dgf1.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/dgf2.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/dgf3.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/dgf4.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>
							<swiper-slide><img src="../assets/xinqingBrand/assets/dgf5.jpg" alt=""
									title="点击跳转商品详情"></swiper-slide>

						</swiper>
					</div>

				</div>

			</div>
		</div>


		<div class="section pageBox6">
			<div class="pageBoxOut2">
				<!-- 底部 -->
				<div class="footerBox">
					<div class="footerBoxHeader">
						<div class="footerBoxHeaderLeft">
							<img class="codeImg" src="../assets/xinqingBrand/assets/code.png" alt="" />
							<span class="codeText">兰树公众号</span>
						</div>
						<div class="footerBoxHeaderCenter">
							<img class="codeImg" src="../assets/xinqingBrand/assets/xcxNew.jpg" alt="" />
							<span class="codeText">兰树云小程序</span>
						</div>
						<div class="footerBoxHeaderRight">
							<img class="codeImg" src="../assets/xinqingBrand/assets/xinqingtang.png" alt="">
							<span class="codeText">官方微信公众号</span>
						</div>
					</div>
					<div class="footerMainBox">
						<li class="footerShop"><a target="_blank"
								href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
						</li>
						<li class="footerShop"><a target="_blank"
								href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
						</li>
						<li class="footerShop"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a></li>
						<li class="footerShop"><a target="_blank"
								href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
						</li>
						<li class="footerShop"><a target="_blank"
								href="https://drchung.tmall.com"><span>Dr.CHUNG</span>旗舰店</a></li>
						<li class="footerShop"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a>
						</li>
						<div class="lastHeader">
							<li><router-link to="/login" tag="a">登录</router-link></li>
							|
							<li><router-link to="/login" tag="a">注册</router-link></li>
						</div>
					</div>

					<div class="footerInfoBox">
						<div class="emailBox">邮箱: postermaster@lasur.com</div>
						<div class="phoneBox">电话: 0571-89025888</div>
						<div class="addressBox">
							地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼
						</div>
					</div>

					<div class="footerLine"></div>
					<div class="footerBoxBottom">
						<div class="footerLeft">
							Copyright © 2023 兰树化妆品股份有限公司
							<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a>
							|
							<img src="../assets/plice.png" />&nbsp;<a target="_blank"
								href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
								33052102000740号</a>
						</div>
					</div>

					<div class="bottom_bg">
						<img src="../assets/xinqingBrand/assets/bottom_bg.png" alt="">
					</div>

				</div>
			</div>

		</div>

	</div>








	<!-- </div> -->

</template>

<script>

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css';
import '../navigation/css/swiper-bundle.min.css'
import Swiper2, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper2.use([Navigation, Pagination, Autoplay]);
export default {
	components: {
		Swiper,
		SwiperSlide,
	},
	data() {
		return {
			drawer: false,
			h: 0,
			brandActive: 1,
			isFixed: false,
			homepage: true,
			series: false,
			product: false,
			swiperOption: {
				observer: true,//修改swiper自己或子元素时，自动初始化swiper
				observeParents: true,//修改swiper的父元素时，自动初始化swiper
				spaceBetween: 0,
				speed: 2000, //速度
				slidesPerView: 3, // 一屏显示的slide个数
				centeredSlides: true,// 居中的slide是否标记为active，默认是最左active,这样样式即可生效
				slideToClickedSlide: true,// 点击的slide会居中
				loop: true,// 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
				autoplay: {
					disableOnInteraction: false,  // 用户操作swiper之后，是否禁止autoplay
					delay: 3000, // 自动切换的时间间隔（单位ms）
				},
				on: {
					// 该方法中的this都指代swiper本身
					tap: function () {
						console.log('点击的位置', this.activeIndex);
					}
				}
			},
			topOption: {
				observer: true,//修改swiper自己或子元素时，自动初始化swiper
				observeParents: true,//修改swiper的父元素时，自动初始化swiper
				spaceBetween: 0,
				speed: 7000, //速度
				slidesPerView: 1, // 一屏显示的slide个数
				centeredSlides: true,// 居中的slide是否标记为active，默认是最左active,这样样式即可生效
				slideToClickedSlide: true,// 点击的slide会居中
				loop: true,// 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
				autoplay: {
					disableOnInteraction: false,  // 用户操作swiper之后，是否禁止autoplay
					delay: 1000, // 自动切换的时间间隔（单位ms）
				},
				on: {
					// 该方法中的this都指代swiper本身
					tap: function () {
						console.log('点击的位置', this.activeIndex);
					}
				}
			},
		};
	},
	mounted() {
		const that = this;

		window.addEventListener('scroll', this.handleScroll)
		// 宽度：
		var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

		// 高度：
		this.h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
		// console.log("页面高度",h)
		// console.log("页面款度",w)


	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	methods: {

		enterHome() {
			this.$router.push({ path: "/" });
		},

		handleScroll() {
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			if (scrollTop >= this.h) {
				this.isFixed = true
			} else {
				this.isFixed = false
			}
		},
		showHomePage() {
			this.homepage = true
			this.series = false
			this.product = false
			document.documentElement.scrollTop = this.h

		},
		showSeries() {
			this.homepage = false
			this.series = true
			this.product = false
			document.documentElement.scrollTop = this.h
		},
		showProduct() {
			this.homepage = false
			this.series = false
			this.product = true
			document.documentElement.scrollTop = this.h
		},

		enterProducts(id) {
			this.$router.push({ path: '/productsList', query: { brandId: id } });
		},

	},
};
</script>

<style scoped>
.slide-left {
	animation: bounceInLeft 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s 1 alternate forwards;
	-webkit-animation: bounceInLeft 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s 1 alternate forwards;
	/*Safari and Chrome*/
}

@keyframes bounceInLeft {
	0% {
		opacity: 0;
		transform: translate3d(-3000px, 0, 0);
	}

	60% {
		opacity: 1;
		transform: translate3d(25px, 0, 0);
	}

	75% {
		transform: translate3d(-10px, 0, 0);
	}

	90% {
		transform: translate3d(5px, 0, 0);
	}

	100% {
		transform: none;
	}
}

.slide-right {
	animation: bounceInRight 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s 1 alternate forwards;
	-webkit-animation: bounceInRight 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s 1 alternate forwards;
	/*Safari and Chrome*/
}

@keyframes bounceInRight {
	0% {
		opacity: 0;
		transform: translate3d(3000px, 0, 0);
	}

	60% {
		opacity: 1;
		transform: translate3d(-25px, 0, 0);
	}

	75% {
		transform: translate3d(10px, 0, 0);
	}

	90% {
		transform: translate3d(-5px, 0, 0);
	}

	100% {
		transform: none;
	}
}


.yiContainer {
	width: 100%;
	overflow: hidden;
	margin: 0;
	padding: 0;
	position: relative;
}


/* 导航 */

/* 下拉菜单栏 选中 */
.navBar {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: absolute;
	justify-content: space-between;
	top: 0;
	background: #ffffff;
	z-index: 999;
}

.navLogo {
	width: 10%;
	margin-left: 5em;
	cursor: pointer;
}

.navBarItem {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
}

.navBarItem li {
	/* list-style: none;
		  padding: 1.5em 2.5em 1.5em 2.5em;
		  float: left; */
	list-style: none;
	/* padding: 25px 40px 25px 40px; */
	float: left;
	/* margin-left: 2em; */
}

.brandLi a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.6em !important;
	padding-bottom: 1.6em !important;
	padding-left: 2em;
	padding-right: 2em;
}

.navBarItem li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.4em;
	padding-bottom: 1.4em;
	padding-left: 1.4rem;
	padding-right: 1.4rem;
}


.elDropdown a {
	color: #111111;
	text-decoration: none;
}



.pageBoxOut2 {
	width: 100%;
	height: 100%;
	justify-content: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
	box-sizing: border-box;
}






/* 首图 */
.topImg {
	/* margin-top: 66px; */
	width: 100%;
	position: fixed;
	background-color: #fff;
	z-index: -1;
	max-height: 462px;
	transition-property: all;
	text-align: center;
}

.topImg img {
	width: 100%;
	height: 100%;
	/* height: 462px; */
}


/*
	轮播图demo
	*/
.banner-container {
	width: 100%;
	height: 100%;
	margin: 0px auto;
	position: relative;
	overflow: hidden;
	/*用于隐藏超出展示容器的内容部分*/
}

.banner-container img {
	width: 100%;
	height: 100%;
}




/* 导航栏 */
.navigation {
	width: 100%;
	height: 5.16vh;
	background-color: #C4C4C4;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
}

.fixed {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 999;
}

.nav_title {
	color: #fff;
	font-size: 1.09375vw;
	font-family: SourceHanSansCN-Regular;
	font-weight: bold;
	cursor: pointer;
}


/* 品牌关键词 */
.brandKeywords {
	height: 110.54vh;
	width: 100vw;
	display: flex;
	flex-direction: row;
	/* justify-content: space-around; */
}

.brandKeywords img {
	width: 100%;
	height: 100%;
}

.keyLeft {
	position: relative;
	margin-top: 20.32vh;
	/* margin-left: 3.7vw; */
}

.keyRight {
	position: relative;
	margin-top: 18.49vh;
	/* margin-left: 17.18vw; */
	/* background: #000; */
}

.left_bg {
	width: 50.5vw;
	/* background: #000; */
	/* height: 62.69vh; */
}

.left_bg img {
	width: 100%;
	height: 100%;
}

.right_bg {
	width: 44.79vw;
	/* z-index: -9; */
	/* height: 707px; */
}

.core_value {
	width: 6.09vw;
	/* height: 81px; */
	position: absolute;
	left: 25.99vw;
	top: 20.67vh;
}

.idea {
	width: 7.81vw;
	/* height: 75px; */
	position: absolute;
	left: 37.26vw;
	top: 26.8vh;
}

.mission {
	width: 12.19vw;
	/* height: 74px; */
	position: absolute;
	left: 13.65vw;
	top: 36.9vh;
}

.location {
	width: 10.78vw;
	/* height: 77px; */
	position: absolute;
	left: 25.99vw;
	top: 43.24vh;
}

.slogan {
	width: 7.29vw;
	/* height: 74p; */
	position: absolute;
	left: 36.875vw;
	top: 58.19vh;
}

.feature {
	width: 10.99vw;
	/* height: 140px; */
	position: absolute;
	left: 26.14vw;
	top: 1.72vh;
}

.vision {
	width: 15.26vw;
	/* height: 81px; */
	position: absolute;
	left: 26.14vw;
	top: 40.97vh;
}

.key {
	width: 7.8125vw;
	/* height: 81px; */
	position: absolute;
	left: 36.98vw;
	top: 64.3vh;
}

.greyTitle {
	margin-top: 10px;
	text-align: left;
	color: #DBDCDC;
	font-size: 100px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	/* display: inline-block; */
	/* transform: scaleY(2); */
	-webkit-transform: skew(-12deg) rotate(-8deg) scaleY(1.2) scaleX(0.85);
	/* for Chrome||Safari */
	-ms-transform: skew(-12deg) rotate(-10deg) scaleY(1.2) scaleX(0.9);
	/* for IE */
	-moz-transform: skew(-12deg) rotate(-10deg) scaleY(1.2) scaleX(0.9);
	/* for Firefox */
	-o-transform: skew(-12deg) rotate(-10deg) scaleY(1.2) scaleX(0.9);
	/* for Opera */
}


/* 品牌介绍 */
.orange {
	width: 100%;
	height: 4.94vh;
	background-color: #FD8204;
}

.orange_bottom {
	width: 100%;
	height: 4.94vh;
	margin-top: 15.05vh;
	background-color: #FD8204;
	line-height: 4.94vh;
	font-size: 1.35vw;
	font-family: Roboto;
	font-weight: 300;
	color: #FFFFFF;
	text-align: center;
}

.butler {
	position: relative;
	width: 100%;
}

.brandIntroduce img {
	width: 100%;
	height: 100%;
}

.butler_en {
	font-size: 1.77vw;
	font-family: Roboto;
	font-weight: 300;
	color: #231815;
	line-height: 2.69vh;
	min-width: 28.59375vw;
	height: 2.69vh;
	text-align: left;
	margin-top: 11.93vh;
	margin-left: 4.64vw;
}

.butler_cn {
	width: 51.30vw;
	height: 11.18vh;
	font-size: 5.57vw;
	font-family: Source Han Sans CN;
	font-weight: 800;
	color: #121317;
	line-height: 11.18vh;
	margin-top: 1.94vh;
	margin-left: 4.64vw;
	text-align: left;
}

.butler_img {
	width: 91.09375vw;
	/* height: 680px; */
	margin-top: 4.3vh;
}

.bd_cn {
	width: 29.17vw;
	height: 7.63vh;
	font-size: 0.9375vw;
	font-family: Source Han Sans CN;
	font-weight: 300;
	color: #000000;
	line-height: 2.54vh;
	text-align: left;
	word-break: break-all;
}

.bd_en {
	margin-top: 7vh;
	width: 29.17vw;
	height: 8.28vh;
	font-size: 0.89vw;
	font-family: Roboto;
	font-weight: 300;
	color: #000000;
	line-height: 2.07vh;
	text-align: left;
	word-break: break-all;
}

.bd_technology {
	margin-top: 8.6vh;
	margin-right: 1.5625vw;
	width: 10.46875vw;
	height: 2.47vh;
	font-size: 1.5625vw;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #EEEEEF;
	line-height: 2.47vh;
	float: right;
}

.butler_detail {
	position: absolute;
	top: 53.98vh;
	right: 3.90625vw;
}


/* 特色 */
.characteristic {
	width: 100%;
	position: relative;
}

.tese_bg {
	margin-top: 11.72vh;
	width: 100%;
	height: 83.33vh;
}

.tes_en {
	width: 32vw;
	height: 16.67vh;
	font-size: 0.89vw;
	line-height: 2.04vh;
	font-family: Roboto;
	font-weight: 300;
	text-align: left;
	/* letter-spacing: 1px; */
	word-break: break-all;
	color: #FFFFFF;
}

.tes_cn {
	margin-top: 10.1vh;
	width: 32.29vw;
	height: 13.12vh;
	font-size: 0.9375vw;
	line-height: 2.58vh;
	font-family: Source Han Sans CN;
	font-weight: 300;
	color: #000000;
	text-align: left;
	word-break: break-all;
}

.tes_technology {
	width: 10.46875vw;
	height: 2.47vh;
	font-size: 1.5625vw;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #000000;
	line-height: 2.47vh;
	float: right;
	margin-top: 26.45vh;
}

.characteristic_detail {
	position: absolute;
	top: 35.91vh;
	right: 3.8541vw;
}

.idealism {
	width: 100%;
	position: relative;
}

.idea_img {
	width: 49.74vw;
	height: 56.13vh;
	margin-top: 10.75vh;
	margin-left: 5.46875vw;
}

.idea_cn {
	width: 31.25vw;
	height: 29.57vh;
	font-size: 0.9375vw;
	line-height: 2.69vh;
	font-family: Source Han Sans CN;
	font-weight: 300;
	color: #000000;
	text-align: left;
	word-break: break-all;
}

.idea_en {
	width: 31.25vw;
	height: 30.22vh;
	font-size: 0.89vw;
	line-height: 2.15vh;
	font-family: Roboto;
	font-weight: 300;
	color: #000000;
	text-align: left;
	word-break: break-all;
	margin-top: 6.99vh;
}

.idea_technology {
	width: 10.46875vw;
	height: 2.47vh;
	font-size: 1.5625vw;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #EEEEEF;
	line-height: 2.17vh;
	float: right;
	margin-top: 7.74vh;
}

.idea_detail {
	position: absolute;
	top: 7.31vh;
	right: 3.85vw;
}

.section {
	margin-top: 200px;
}

.pageBox6 {
	/* margin-top: 100px; */
	width: 100%;
	height: 653px;
	display: flex;
	flex-direction: column;
	color: #000;
	/* background-image: url("../assets/page6_bg.png"); */
	/* background:linear-gradient(to top, #9D92BF, #ECEAF2, #FCFCFD,#fff); */
}

/* footer */
.footerBox {
	width: 100%;
	/* height: 287px; */
	/* position:absolute;
		   	bottom:0; */
	margin: 0 auto;
	flex-direction: column;
	z-index: 999;
}

.footerBoxHeader {
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 2%;
}

.footerBoxHeaderLeft {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.footerBoxHeaderCenter {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}


.footerBoxHeaderRight {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.codeImg {
	width: 90px;
}

.codeText {
	font-size: 0.88em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 20px;
	margin-top: 0.5rem;
}

.footerLine {
	width: 79%;
	height: 1px;
	display: flex;
	background: #000;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 1em;
}

.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
}

.emailBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 20px;
}

.phoneBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 20px;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 1rem;
}

.footerLeft {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 24px;
}

.footerBoxBottom .footerLeft img {
	height: 16px;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #000;
}

.footerLeft a:hover {
	color: #000;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 28px;
	margin-left: 2em;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.875rm;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerMainBox {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 2em;
}

.footerShop {
	list-style: none;
	position: relative;
}

.footerShop span {
	margin-right: 10px;
}

.footerShop span::after {
	content: '+';
	display: block;
	position: absolute;
	top: -6px;
	right: 43px;
}

.footerShop a {
	text-decoration: none;
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	padding-left: 2em;
	line-height: 28px;
	cursor: pointer;
}

.bottom_bg {
	width: 100%;
	height: 326px;
}

.bottom_bg img {
	width: 100%;
	height: 100%;
}




/* 套盒系列 */
.product,
.series {
	margin-bottom: 53.76vh;
}

.product img {
	width: 100%;
	height: 100%;
}

.series img {
	width: 100%;
	height: 100%;
}

.series_top .sstop_en {
	margin-top: 12.9vh;
	margin-left: 3.02vw;
	width: 58.23vw;
	height: 5.27vh;
}

.series_top .sstop_cn {
	margin-top: 5.59vh;
	margin-left: 3.02vw;
	width: 58.23vw;
	height: 19.89vh;
}

.sstop_right {
	margin-top: 23.12vh;
	float: right;
	margin-right: 3.96vw;
}

.ssright_cn {
	width: 10.42vw;
	height: 20.86vh;
	font-size: 5.16vw;
	font-family: Source Han Sans CN;
	font-weight: 800;
	color: #040000;
	line-height: 10.54vh;
}

.ssright_en {
	margin-top: 1.72vh;
	width: 9.95vw;
	height: 4.73vh;
	font-size: 3.177vw;
	font-family: Roboto;
	font-weight: 100;
	color: #121317;
	line-height: 4.73vh;
}

/* 源生赋新套 */
.newSeries {
	margin-top: 51.61vh;
	position: relative;
	width: 100%;
}

.ns_title {
	margin-top: 18.17vh;
	margin-left: 3.7vw;
}

.ns_cn {
	width: 31.25vw;
	height: 8.39vh;
	font-size: 3.8vw;
	font-family: Source Han Sans CN;
	font-weight: 800;
	color: #231815;
	line-height: 8.39vh;
	text-align: left;
	/* background-color: #FD8204; */
}

.pd_cn {
	margin-top: 1.08vh;
	width: 20.3125vw;
	height: 6.24vh;
	font-size: 3.02vw;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #DBDCDC;
	line-height: 6.24vh;
	/* background-color: #FF8300; */
	text-align: left;
}

.pd_en {
	margin-top: -6.24vh;
	width: 30.2vw;
	height: 5.48vh;
	font-size: 0.99vw;
	font-family: Roboto;
	font-weight: 300;
	color: #231815;
	line-height: 2.04vh;
	text-align: right;
}

.ns_en {
	width: 16.5625vw;
	height: 2.9vh;
	font-size: 0.78125vw;
	font-family: Roboto;
	font-weight: 300;
	color: #231815;
	line-height: 1.61vh;
	text-align: left;
	margin-top: 6.56vh;
}

.paragraph_24 {
	position: absolute;
	left: 3.39vw;
	top: 32.26vh;
	width: 31.25vw;
	height: 8.817vh;
	overflow-wrap: break-word;
	color: rgba(219, 220, 220, 1);
	font-size: 2.5vw;
	font-family: Roboto-Black;
	font-weight: bolder;
	text-align: right;
	white-space: nowrap;
	line-height: 4.4vh;
	/* background-color: #FD8204; */
}

.bottom-title {
	margin-top: 4.52vh;
	width: 26.5625vw;
	height: 5.8vh;
	text-align: left;
}

.yellow_left {
	font-size: 0.68vw;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #FF8300;
	/* line-height: 21px; */
}

.black_right {
	font-size: 0.68vw;
	font-family: SourceHanSansCN-Bold;
	font-weight: bold;
	color: #231815;
	/* line-height: 21px; */
}

.content {
	position: absolute;
	top: 21.5vh;
	right: 4.27vw;
	width: 55.15625vw;
	height: 58.17vh;
	display: flex;
	flex-direction: row;
}

.swiper {
	width: 55.15625vw;
	height: 58.17vh;

}

.swiper-slide {
	height: 58.17vh;
	width: 18.39vw;
	cursor: pointer;
}

.swiper-container {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/brandNew.vue